import React, { useEffect, useMemo, useRef, useState } from "react";
import "../index.css";

const clamp01 = (n) => Math.min(1, Math.max(0, n));
const smoothstep = (t) => t * t * (3 - 2 * t);
const lerp = (a, b, t) => a + (b - a) * t;

function mixRGBA(a, b, t) {
  const r = Math.round(lerp(a.r, b.r, t));
  const g = Math.round(lerp(a.g, b.g, t));
  const bb = Math.round(lerp(a.b, b.b, t));
  const alpha = lerp(a.a, b.a, t);
  return `rgba(${r}, ${g}, ${bb}, ${alpha})`;
}

function mixRGBString(a, b, t, alpha = 1) {
  const r = Math.round(lerp(a[0], b[0], t));
  const g = Math.round(lerp(a[1], b[1], t));
  const bb = Math.round(lerp(a[2], b[2], t));
  return `rgba(${r}, ${g}, ${bb}, ${alpha})`;
}

export default function BlackLockAndTextRevealMobile({
  sectionVh = 120,
  from = { r: 252, g: 249, b: 248, a: 1 },
  to = { r: 24, g: 21, b: 20, a: 1 },
  prefix = "",
  words = ["Break", "up", "with", "your", "bank."],
}) {
  const ref = useRef(null);

  const [bgT, setBgT] = useState(0);
  const [revealT, setRevealT] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let raf = 0;

    const update = () => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight || 1;

      const start = vh * 0.9;
      const end = -rect.height * 0.2;
      const progress = clamp01((start - rect.top) / (start - end));
      const eased = smoothstep(progress);

      setBgT(eased);
      setRevealT(eased);
      raf = 0;
    };

    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const bg = useMemo(() => mixRGBA(from, to, bgT), [from, to, bgT]);

  const textFlipT = clamp01((bgT - 0.55) / 0.35);
  const baseText = mixRGBString(
    [24, 21, 20],
    [252, 249, 248],
    smoothstep(textFlipT),
    1
  );

  // Always show at least the first word so mobile never looks blank
  const visibleCount = Math.max(
    1,
    Math.min(words.length, Math.ceil(revealT * words.length))
  );

  const shown = words.slice(0, visibleCount);

  return (
    <section
      ref={ref}
      style={{
        position: "relative",
        minHeight: `${sectionVh}vh`,
        backgroundColor: bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 20px",
      }}
    >
      <h1
        style={{
          margin: 0,
          fontFamily: "Blackletter, Helvetica, Arial, sans-serif",
          fontWeight: 100,
          letterSpacing: "-0.01em",
          lineHeight: 0.98,
          fontSize: "clamp(42px, 13vw, 68px)",
          color: baseText,
          textAlign: "center",
          maxWidth: "8ch",
          width: "100%",
        }}
      >
        {prefix}
        {prefix && shown.length ? " " : ""}
        {shown.join(" ")}
      </h1>
    </section>
  );
}
